import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {useDispatch} from "react-redux";
import {closeDialog} from "../../../../store/actionCreators/dialog";

const options = ['current', 'all'];

const UnionAuthority =() => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [selectedOption, selectOption]= useState('current');

    const changeAuthority = () => {
        dispatch(closeDialog());
    };

    return (
        <React.Fragment>
           <p className = {`selectAuthorityText`}>{t('dialog.selectAuthority.text')}</p>
           {options.map((option) => (
            <div className = {`options`}>
                <input type="radio" id = {option} value = {option} checked={option === selectedOption}
                    onChange = {() => selectOption(option)}
                />
                <label for={[option]}>{t(`dialog.selectAuthority.${option}`)}</label>
            </div>
           ))}
           <div className="dialogConfirmBox">
                <button className={'primary'} onClick={changeAuthority} >
                    {t('button.confirm')}
                </button>
            </div>
        </React.Fragment>
    );
};

export default UnionAuthority;

